import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import AgeVerification from './components/AgeVerification';
import CookiePopup from './components/CookiePopup';
import BackToTop from './components/BackToTop';
import WarningBanner from './components/WarningBanner';
import ScrollToTop from './components/ScrollToTop';

// Lazy load pages for better performance
const Home = lazy(() => import('./pages/Home'));
const Comparison = lazy(() => import('./pages/Comparison'));
const About = lazy(() => import('./pages/About'));
const FAQ = lazy(() => import('./pages/FAQ'));
const OfferReview = lazy(() => import('./pages/OfferReview'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const CookiePolicy = lazy(() => import('./pages/CookiePolicy'));
const TermsOfService = lazy(() => import('./pages/TermsOfService'));

const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-dark-bg">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-accent-primary"></div>
  </div>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-dark-bg">
        <WarningBanner />
        <Header />
        <AgeVerification />
        <CookiePopup />
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/comparaison" element={<Comparison />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/offres/:id" element={<OfferReview />} />
            <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
            <Route path="/cookies" element={<CookiePolicy />} />
            <Route path="/conditions-utilisation" element={<TermsOfService />} />
          </Routes>
        </Suspense>
        <BackToTop />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
